import goldLog from '../utils/log';
import { getServerTime } from '../module/server-time';
var DefaultLogMsgIdInterval = 10000;
var DefaultLogBatchCount = 10;
export var SyncMtopLogKey = '/instantmessaging.common.sync.messages';
export var SyncAccsLogKey = '/instantmessaging.common.sync.messages.accs';
var getMatch = function (regex, str) {
    var tokens = str.match(regex);
    return tokens && tokens[1] ? tokens[1] : null;
};
export function mtopMsgToLog(message) {
    if (message.log_time) {
        return message;
    }
    var body = message.body || {};
    var typeData = body.typeData || {};
    var direction = /2/.test(typeData.fromType) ? 'sellerToBuyer' : 'buyerToSeller';
    var buyer_user_id;
    var seller_user_id;
    if (typeData.ext) {
        var _a = typeData.ext, fromAccountId = _a.fromAccountId, routeAccountId = _a.routeAccountId;
        buyer_user_id = direction === 'sellerToBuyer' ? routeAccountId : fromAccountId;
        seller_user_id = direction === 'sellerToBuyer' ? fromAccountId : routeAccountId;
    }
    else {
        buyer_user_id = getMatch(/(\d{4,20})#1/, typeData.sid);
        seller_user_id = getMatch(/(\d{4,20})#2/, typeData.sid);
    }
    return {
        buyer_user_id: buyer_user_id,
        seller_user_id: seller_user_id,
        message_id: typeData.mid,
        direction: direction,
        send_time: typeData.sendTime,
        log_time: getServerTime(),
    };
}
export function accsMsgToLog(message) {
    if (message.log_time) {
        return message;
    }
    return {
        buyer_user_id: message.buyerUserId,
        seller_user_id: message.sellerId,
        message_id: message.messageId,
        direction: message.direction,
        send_time: message.sendTime,
        log_time: getServerTime(),
    };
}
var Tool = {
    cache: new Map(),
    config: undefined,
    isInited: false,
    timer: undefined,
    init: function (config) {
        if (Tool.timer) {
            return;
        }
        Tool.cache = new Map();
        Tool.config = config;
        clearInterval(Tool.timer);
        Tool.timer = setInterval(function () {
            Tool.logMsgAndCleanCache(SyncMtopLogKey, mtopMsgToLog);
            Tool.logMsgAndCleanCache(SyncAccsLogKey, accsMsgToLog);
        }, config.logMsgIdInterval || DefaultLogMsgIdInterval);
        window.addEventListener('beforeunload', function () {
            clearInterval(Tool.timer);
            Tool.logMsgAndCleanCache(SyncMtopLogKey, mtopMsgToLog);
            Tool.logMsgAndCleanCache(SyncAccsLogKey, accsMsgToLog);
        });
        Tool.isInited = true;
    },
    saveSyncMsgCache: function (input, key) {
        var lastArr = Tool.cache.get(key) || [];
        var itemArr = Array.isArray(input) ? input : [input];
        Tool.cache.set(key, lastArr.concat(itemArr));
    },
    logMsgAndCleanCache: function (logKey, adapter) {
        var messageArr = Tool.cache.get(logKey) || [];
        Tool.cache.set(logKey, []);
        while (messageArr.length > 0) {
            var batchMessages = messageArr
                .splice(0, DefaultLogBatchCount)
                .map(adapter);
            Tool.logSyncMessageId(batchMessages, logKey);
        }
    },
    logSyncMessageId: function (messageArr, key) {
        var _a;
        var configFunc = (_a = Tool.config._url.logSyncMessageId) !== null && _a !== void 0 ? _a : goldLog;
        configFunc({
            key: key,
            os: navigator ? navigator.userAgent : 'unknown',
            config: Tool.config,
            data: {
                message_arr: JSON.stringify(messageArr),
            },
        });
    },
};
export default Tool;
